import { CalendarMeetingLinkTypeKey } from '@/modules/calendarmeetinglink/enums/CalendarMeetingLinkTypeKey';
import Lang from '@/modules/core/app/services/Lang';
import { EstateProductType } from '@/modules/estate/enums/EstateProductType';
import Enum from '/@/modules/core/app/helpers/Enum';

export class CalendarMeetingLinkType extends Enum {
  key!: CalendarMeetingLinkTypeKey;
  value!: string;
  category!: string;

  static INTAKE: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.INTAKE,
    get value() {
      return Lang.t('user.intake-meeting');
    },
    category: EstateProductType.PLANNING.key
  };

  static GUIDANCE: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.GUIDANCE,
    get value() {
      return Lang.t('user.guidance-meeting');
    },
    category: EstateProductType.PLANNING.key
  };

  static WILL_REVIEW: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.WILL_REVIEW,
    get value() {
      return Lang.t('user.will-review-meeting');
    },
    category: EstateProductType.PLANNING.key
  };

  static WILL_NOTARIZATION: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.WILL_NOTARIZATION,
    get value() {
      return Lang.t('will.will-notarization');
    },
    category: EstateProductType.PLANNING.key
  };

  static PROTECTION_MANDATE_NOTARIZATION: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.PROTECTION_MANDATE_NOTARIZATION,
    get value() {
      return Lang.t('protectionmandate.notarization');
    },
    category: EstateProductType.PLANNING.key
  };

  static WILL_AND_PROTECTION_MANDATE_NOTARIZATION: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.WILL_AND_PROTECTION_MANDATE_NOTARIZATION,
    get value() {
      return `${Lang.t('will.will-notarization')} ${Lang.t('core.and')} ${Lang.t(
        'protectionmandate.notarization'
      )}`;
    },
    category: EstateProductType.PLANNING.key
  };

  static ANNUAL_REVIEW: CalendarMeetingLinkType = {
    key: CalendarMeetingLinkTypeKey.ANNUAL_REVIEW,
    get value() {
      return Lang.t('user.annual-review-meeting');
    },
    category: EstateProductType.PLANNING.key
  };
}
